import BusinessCenterRoundedIcon from "@mui/icons-material/BusinessCenterRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import PaidIcon from '@mui/icons-material/Paid';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import SendIcon from '@mui/icons-material/Send';
import { Box, Button, Chip, Grid, Modal, Paper, TextField, Tooltip, Typography, styled, Divider } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useFormik } from "formik";
import 'jspdf-autotable';
import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import Header from "../components/Header";
import RestoreRoundedIcon from '@mui/icons-material/RestoreRounded';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    borderStyle: 'groove',
    border: '3px',
    borderColor:'grey',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)',
    marginTop: '10px',
    minHeight:'50px',
    borderRadius:'10px'
  }));

const KpeeLogistics = () => {
  const [societies_data, setSocieties_data] = useState([]);
  const [in_what, setIn_what] = useState('');
  const [in_what_id, setIn_what_id] = useState(null);
  const [show_one, setShow_one] = useState(false);
  const [log_data, setLog_data] = useState([]);
  const [inv_generator, setInv_generator] = useState([]);
  const [groups, setGroups] = useState([]);
  const [open_model, setOpen_model] = useState(false);
  const [editing_mode, setEditing_mode] = useState(false);
  const [open_account, setOpen_account] = useState(false);
  const [kpee_accounts, setKpee_accounts] = useState([]);
  const [hold_waybill, setHold_waybill] = useState([]);
  const [hold_waybill_open, setHold_waybill_open] = useState(false);

  const resetWaybill = (row) => {
    toast.promise(
      api.get(`/association/reverse/invoice/${row.id}`, {
          headers: {
              Authorization: "Bearer " + fetchToken(),
          },
      }),
      {
          loading: "Resetting Invoice...",

          success: (response) => {
            openSociety(in_what_id);

            return response.data
          },
          error: (error) => {
              console.error("Error generating waybill:", error);
              return "Failed to generate waybill. Please try again.";
          },
      }
  );
  }
  const generateWaybill = () => {
    toast.promise(
        api.get(`/association/generate/waybill/yes/logistic/data/${hold_waybill.id}`, {
            headers: {
                Authorization: "Bearer " + fetchToken(),
            },
            responseType: 'blob', // Set the response type to 'blob'
        }),
        {
            loading: "Generating Receipt...",

            success: (response) => {
                 // Create a URL for the blob
                 const url = window.URL.createObjectURL(new Blob([response.data]));
                 const a = document.createElement('a');
                 a.href = url;
                 a.download = `waybill_${hold_waybill.tag}.pdf`; 
                 document.body.appendChild(a);
                 a.click(); // Trigger the download
                 a.remove(); // Clean up
 
                 return "Waybill generated successfully!";
            },
            error: (error) => {
                console.error("Error generating waybill:", error);
                return "Failed to generate waybill. Please try again.";
            },
        }
    );
}

const mailWaybill = () => {
  toast.promise(
    api.get(`/association/send/waybill/to/email/${hold_waybill?.id}`, {
        headers: {
            Authorization: "Bearer " + fetchToken(),
        },
    }),
    {
        loading: "Sending Waybill...",

        success: (response) => {

             return response.data;
        },
        error: (error) => {
            console.error("Error generating waybill:", error);
            return "Failed to generate waybill. Please try again.";
        },
    }
);
}

  const prepareWaybill = (row) => {
    setHold_waybill(row);
    setHold_waybill_open(true);
    way_formik.setFieldValue("id", row.id)
    way_formik.setFieldValue("dispatch_date", row.dispatch_date)
    way_formik.setFieldValue("delivery_method", row.delivery_method)
    way_formik.setFieldValue("driver_contact", row.driver_contact)
    way_formik.setFieldValue("driver_license_number", row.driver_license_number)
    way_formik.setFieldValue("driver_name", row.driver_name)
    way_formik.setFieldValue("delivery_company", row.delivery_company)
    way_formik.setFieldValue("delivery_address", row.delivery_address)
    way_formik.setFieldValue("receiver_contact", row.receiver_contact)
    way_formik.setFieldValue("receiver_name", row.receiver_name)
    way_formik.setFieldValue("receiver_address", row.receiver_address)
  }

  const closePreparedWaybill = () => {
    setHold_waybill([]);
    setHold_waybill_open(false);
    way_formik.handleReset();
  }

  const deleteLog = (id) => {
    toast.promise(
      api
      .delete(
        `/association/delete/society/logistic/data/${id}`,
        {
          headers: {
            Authorization: "Bearer " + fetchToken(),
            "Content-Type": "multipart/form-data",
          },
        }
      ),
      {
          loading: 'Deleting account...',
          success: (response) => {
              
              getData();
              openSociety()

              return response.data
          },
          error: (error) => {
              console.log(error);
              
              return 'Error, Please try again'
          }
      }
  )
  }

  const editAccount = (row) => {
    // console.log(row)
    formik.setFieldValue("id", row.id)
    formik.setFieldValue("account_provider", row.account_provider)
    formik.setFieldValue("account_type", row.account_type)
    formik.setFieldValue("account_number", row.account_number)
    formik.setFieldValue("account_name", row.account_name)
    formik.setFieldValue("holders_contact", row.holders_contact)
    setEditing_mode(true)
  }

  const deleteAccount = (id) => {
    toast.promise(
      api
      .get(
        `/association/delete/kpee/account/${id}`,
        {
          headers: {
            Authorization: "Bearer " + fetchToken(),
            "Content-Type": "multipart/form-data",
          },
        }
      ),
      {
          loading: 'Deleting account...',
          success: (response) => {
              setEditing_mode(false);
              formik.handleReset();
              getData();

              return response.data
          },
          error: (error) => {
              console.log(error);
              
              return 'Error, Please try again'
          }
      }
  )
  }

  const closeAccount = () => {
    setOpen_account(false);
    setEditing_mode(false);
    formik.handleReset(); 
  }


  const way_formik = useFormik({
    initialValues: {
      id: "",
      dispatch_date: "",
      delivery_method: "", 
      driver_contact: "",
      driver_license_number: "",
      driver_name: "",
      delivery_company: "",
      delivery_address: "",
      receiver_contact: "",
      receiver_name: "",
      receiver_address: ""
    },
    onSubmit: (values) => {
      const data = new FormData();
      data.append("dispatch_date", values.dispatch_date);
      data.append("delivery_method", values.delivery_method);
      data.append("driver_contact", values.driver_contact);
      data.append("driver_license_number", values.driver_license_number);
      data.append("driver_name", values.driver_name);
      data.append("delivery_company", values.delivery_company);
      data.append("delivery_address", values.delivery_address);
      data.append("receiver_contact", values.receiver_contact);
      data.append("receiver_name", values.receiver_name);
      data.append("receiver_address", values.receiver_address);
      data.append("id", values.id);
    
      toast.promise(
          api
          .post(
            "/association/save/logistic/group/waybill",
            data,
            {
              headers: {
                Authorization: "Bearer " + fetchToken(),
                "Content-Type": "multipart/form-data",
              },
            }
          ),
          {
              loading: 'Updating waybill...',
              success: (response) => {
                  openSociety()
                  setHold_waybill(response.data?.data)
                  closePreparedWaybill()
                  return "Waybill updated successfully"
              },
              error: (error) => {
                  console.log(error);
                  
                  return 'Error, Please try again'
              }
          }
      )
    },
  });

  const formik = useFormik({
    initialValues: {
      account_provider_id: "",
      account_provider: "", 
      account_type: "",
      account_number: "",
      account_name: "",
      holders_contact: ""
    },
    onSubmit: (values) => {
      const data = new FormData();
      data.append("account_provider", values.account_provider);
      data.append("account_type", values.account_type);
      data.append("account_number", values.account_number);
      data.append("account_name", values.account_name);
      data.append("holders_contact", values.holders_contact);
      
      if(editing_mode){
        data.append("account_provider_id", values.account_provider_id);
      }
      
    
      toast.promise(
          api
          .post(
            "/association/add/new/kpee/account",
            data,
            {
              headers: {
                Authorization: "Bearer " + fetchToken(),
                "Content-Type": "multipart/form-data",
              },
            }
          ),
          {
              loading: !editing_mode?'Creating request...': 'Editing request...',
              success: (response) => {
                  setEditing_mode(false);
                  formik.handleReset();
                  getData();
                  return response.data
              },
              error: (error) => {
                  console.log(error);
                  
                  return 'Error, Please try again'
              }
          }
      )
    },
  });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    maxHeight: "80vh",
    minHeight: "70vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };
 
  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxHeight: "80vh",
    minHeight: "70vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const openInvoice = () => {
    setOpen_model(true);
  }

  const closeInvoice = () => {
    setOpen_model(false);
  }



  
  const generateInvoice = (invoice_id) => {
    toast.promise(
        api.get(`/association/generate/invoice/logistic/data/${invoice_id}`, {
            headers: {
                Authorization: "Bearer " + fetchToken(),
            },
            responseType: 'blob', // Set the response type to 'blob'
        }),
        {
            loading: "Generating Invoice...",

            success: (response) => {
                 // Create a URL for the blob
                 const url = window.URL.createObjectURL(new Blob([response.data]));
                 const a = document.createElement('a');
                 a.href = url;
                 a.download = `invoice_${invoice_id}.pdf`; // Use invoice_id instead of invoice.id
                 document.body.appendChild(a);
                 a.click(); // Trigger the download
                 a.remove(); // Clean up
 
                 return "Invoice generated successfully!";
            },
            error: (error) => {
                console.error("Error generating invoice:", error);
                return "Failed to generate invoice. Please try again.";
            },
        }
    );
};

const mailInvoice = (invoice_id) => {
  toast.promise(
    api.get(`/association/send/invoice/to/email/${invoice_id}`, {
        headers: {
            Authorization: "Bearer " + fetchToken(),
        },// Set the response type to 'blob'
    }),
    {
        loading: "Sending Invoice...",

        success: (response) => {

             return response.data;
        },
        error: (error) => {
            console.error("Error generating invoice:", error);
            return "Failed to generate invoice. Please try again.";
        },
    }
);
}


  
  const totalPrice = log_data?.reduce((sum, row) => {
      const item = inv_generator?.find(item => item.id === row.id);
      return sum + (item?.price_per ? item.price_per * row.qty : 0);
  }, 0);


  const generate_setup_group = () => {
    const data = {
        id: in_what_id,
        data: inv_generator
    }
    toast.promise(
        api.post('/association/save/logistic/group', data, {
                headers: {
                Authorization: "Bearer " + fetchToken(),
            },
        }),
        {
            loading: "Setting Up...",
            success: (response) => {
                getData();
                setInv_generator([]);
                openSociety();

                return response.data
            },
            error: (error) => {
                console.log(error);

                return 'Error, Please Refresh page'
            }
        }
    )
  }
 

  const priceItUp = (id, price) => {
    setInv_generator((prev) => {
        if (price === "" || price === null) {
            // Remove the item if price is cleared
            return prev.filter(item => item.id !== id);
        }

        // Check if the item already exists
        const existingItemIndex = prev.findIndex(item => item.id === id);
        if (existingItemIndex !== -1) {
            // Update the existing item
            const updatedArray = [...prev];
            updatedArray[existingItemIndex] = { id, price_per: price };
            return updatedArray;
        } else {
            // Add a new item
            return [...prev, { id, price_per: price }];
        }
    });
  }

  function formatDateToYearMonthDay(date) {
        const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
        ];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        let suffix = "th";

        if (day === 1 || day === 21 || day === 31) {
        suffix = "st";
        } else if (day === 2 || day === 22) {
        suffix = "nd";
        } else if (day === 3 || day === 23) {
        suffix = "rd";
        }

        return `${day}${suffix} ${month} ${year}`;
    }

  const getData = () => {
    toast.promise(
      api.get("/association/get/kpee/logistic/data", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Loading...",
        success: (response) => {
          setSocieties_data(response.data.data);
          setKpee_accounts(response.data.accounts)

          return "Data Loaded Successfully";
        },
        error: (error) => {
          console.log(error);

          return "Error, Please Refresh page";
        },
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const openSociety = (id, name) => {
    const idd = id ? id : in_what_id
    const namee = name ? name :in_what
    toast.promise(
      api.get(`/association/get/kpee/society/logistic/data/${idd}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Loading...",
        success: (response) => {
          setLog_data(response.data.data);
          setIn_what(name);
          setIn_what_id(idd);
          setShow_one(true);
          setGroups(response.data.groups);

          return "Data Loaded Successfully";
        },
        error: (error) => {
          console.log(error);

          return "Error, Please Refresh page";
        },
      }
    );
  };


    const currencyFormat = new Intl.NumberFormat('en-GH', {
      style: 'currency',
      currency: 'GHS',
    });

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 3 }}>
          {/* HEADER */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header title="Kibbutz Pishon" subtitle="Logistics Operations" />
          </Box>
          <Box>
            <Typography
              variant="h3"
              sx={{ textAlign: "center", m: 1 }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>Kpee Setup Logistics Operations</b>
            </Typography>
            <Typography
              variant="h6"
              sx={{ textAlign: "center", m: 0.5 }}
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>{show_one?in_what:""}</b>
            </Typography>
          </Box>
          {/* main content */}
          <Box>
            {show_one ? (
              <Chip
                size="small"
                label={
                  <Typography
                    variant="subtitle"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Back to Societies</b>
                  </Typography>
                }
                icon={<KeyboardBackspaceRoundedIcon sx={{ color: "#fff" }} />}
                sx={{
                  borderRadius: 2,
                  m: 1,
                  boxShadow:
                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#2b2d42",
                  color: "#fff",
                  "&:hover": {
                    boxShadow:
                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                    backgroundColor: "#14213d",
                  },
                }}
                onClick={() => setShow_one(false)}
              />
            ) : null}
          </Box>
          <Grid container spacing={2}>
            {!show_one ? (
              <Grid item xs={12} md={12}>
                <Box>
                  <Button
                    onClick={() => setOpen_account(true)}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 2,
                      m: 1,
                      backgroundColor: "#000",
                      color: "#fff",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                        boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                      },
                    }}
                  >
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Kpee Accounts Setup</b>
                    </Typography>
                  </Button>
                </Box>
                <Box
                  sx={{
                    overflow: "auto",
                    marginBottom: 10,
                    maxHeight: 340,
                    "&::-webkit-scrollbar": {
                      width: "7px",
                      height: "7px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#888",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#555",
                    },
                  }}
                >
                  <Table size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>No.</b>
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Society</b>
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Pending Requests</b>
                          </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Logistics request delivered</b>
                          </Typography>{" "}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {societies_data?.map((row, index) => (
                        <TableRow
                          key={row.index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            backgroundColor: "#f5f3f4",
                          }}
                        >
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{index + 1}</b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{row.society_name}</b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography
                              sx={{
                                color:
                                  row.total_pending === 0 ? "black" : "red",
                              }}
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>{row.total_pending}</b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>{row.total_delivered}</b>
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <Button
                                size="small"
                                color="success"
                                variant="contained"
                                sx={{
                                  borderRadius: 2,
                                  boxShadow:
                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                  "&:hover": {
                                    boxShadow:
                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                    backgroundColor: "#14213d",
                                  },
                                }}
                                onClick={() => openSociety(row.id, row.society)}
                              >
                                <BusinessCenterRoundedIcon />
                              </Button>
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              </Grid>
            ) : (
              <Grid item xs={12} md={12}>
                <Grid container spacing={2}>

                    <Grid item xs={12} md={4}>
                        <Item>
                            <Typography sx={{textAlign:'center'}} variant="h4" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Setups</b>
                            </Typography>

                            <Box
                                sx={{
                                    overflow: "auto",
                                    marginBottom: 10,
                                    maxHeight: 340,
                                    "&::-webkit-scrollbar": {
                                    width: "7px",
                                    height: "7px",
                                    },
                                    "&::-webkit-scrollbar-track": {
                                    background: "#f1f1f1",
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                    background: "#888",
                                    borderRadius: "10px",
                                    },
                                    "&::-webkit-scrollbar-thumb:hover": {
                                    background: "#555",
                                    },
                                }}
                                >
                                {log_data.every(item => item.status !== "Pending Request") ? (
                                    <Typography
                                        sx={{ m: 1 }}
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                    <b>No Pending Requests Yet</b>
                                    </Typography>
                                ) : null}

                                <Table size="small" aria-label="a dense table">
                                    <TableHead>
                                    <TableRow>
                                        {/* <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>No.</b>
                                            </Typography>{" "}
                                        </TableCell> */}
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Logistic</b>
                                            </Typography>{" "}
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Quantity</b>
                                            </Typography>{" "}
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Set Price for one</b>
                                            </Typography>{" "}
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Total</b>
                                            </Typography>{" "}
                                        </TableCell>
                                    </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {log_data?.filter(row => row.status === "Pending Request").map((row, index) =>  (
                                        <TableRow
                                            key={row.index}
                                            sx={{
                                                "&:last-child td, &:last-child th": {
                                                border: 0,
                                                },
                                                backgroundColor: "#f5f3f4",
                                            }}
                                        >
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.log_name}</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.qty}</b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b> 
                                                    <TextField
                                                        size="small"
                                                        sx={{ width:'10ch' }}
                                                        value={inv_generator?.find(item => item.id === row.id)?.price_per || ""}
                                                        onChange={(e) => priceItUp(row.id, e.target.value)}
                                                        placeholder="100.50"
                                                    />
                                                </b>
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>
                                                    {currencyFormat.format(inv_generator?.find(item => item.id === row.id)?.price_per ? inv_generator?.find(item => item.id === row.id)?.price_per * row.qty: 0)}
                                                </b>
                                            </Typography>
                                        </TableCell>
                                        </TableRow>
                                    ))}
                                        <TableRow
                                            sx={{
                                                "&:last-child td, &:last-child th": {
                                                border: 0,
                                                },
                                                backgroundColor: "#f5f3f4",
                                            }}
                                        >
                                            <TableCell align="left">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Totals</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b></b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b></b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                    <b>
                                                        {currencyFormat.format(totalPrice?totalPrice:0)}
                                                    </b>
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                </Box>

                                <Box sx={{ display:'flex', flexDirection:'row' }}>
                                    <Button
                                        size="small"
                                        color="error"
                                        variant="contained"
                                        sx={{
                                        borderRadius: 2,
                                        m: 1,
                                        boxShadow:
                                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        "&:hover": {
                                            boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                            backgroundColor: "#14213d",
                                        },
                                        }}
                                        onClick={() => setInv_generator([])}
                                    >
                                        Reset
                                    </Button>

                                    <Button
                                        size="small"
                                        color="success"
                                        variant="contained"
                                        sx={{
                                        borderRadius: 2,
                                        m: 1,
                                        boxShadow:
                                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        "&:hover": {
                                            boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                            backgroundColor: "#14213d",
                                        },
                                        }}
                                        onClick={generate_setup_group}
                                        disabled={!inv_generator[0]}
                                    >
                                        Complete Setup
                                    </Button>
                                </Box>
                        </Item>
                    </Grid>

                    <Grid item xs={12} md={8}>
                        <Item>
                            <Typography variant="h4" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                                <b>Forms</b>
                            </Typography>
                            <Box
                                sx={{
                                overflow: "auto",
                                marginBottom: 10,
                                maxHeight: 340,
                                "&::-webkit-scrollbar": {
                                    width: "7px",
                                    height: "7px",
                                },
                                "&::-webkit-scrollbar-track": {
                                    background: "#f1f1f1",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                    background: "#888",
                                    borderRadius: "10px",
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                    background: "#555",
                                },
                                }}
                            >
                                {!groups[0] ? (
                                <Typography
                                    sx={{ m: 1 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                >
                                    <b>No Forms Available</b>
                                </Typography>
                                ) : null}

                                <Table size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Tag</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Items(No.)</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Total Quantity</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Total Amount</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Status</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Invoice</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Mail Invoice</b>
                                        </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Waybill</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    <TableCell align="left">
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Reset</b>
                                      </Typography>{" "}
                                    </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {groups?.map((row, index) => (
                                    <TableRow
                                        key={row.index}
                                        sx={{
                                        "&:last-child td, &:last-child th": {
                                            border: 0,
                                        },
                                        backgroundColor: "#f5f3f4",
                                        }}
                                    >
                                        <TableCell align="left">
                                        <Typography onClick={() => openInvoice(row.id)} sx={{ textDecoration:'underline', pointer:'cursor', color:'blue' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>#{row.tag}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.total_logs}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.total_quantity}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{currencyFormat.format(row.total_amount)}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>{row.status}</b>
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <Button
                                                size="small"
                                                color="success"
                                                variant="contained"
                                                sx={{
                                                borderRadius: 2,
                                                boxShadow:
                                                    "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                "&:hover": {
                                                    boxShadow:
                                                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                    backgroundColor: "#14213d",
                                                },
                                                }}
                                                onClick={() => generateInvoice(row.id)}
                                            >
                                                <ReceiptRoundedIcon />
                                            </Button> 
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                              <Button
                                                    size="small"
                                                    color="success"
                                                    variant="contained"
                                                    sx={{
                                                    borderRadius: 2,
                                                    boxShadow:
                                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                    "&:hover": {
                                                        boxShadow:
                                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                        backgroundColor: "#14213d",
                                                    },
                                                    }}
                                                    onClick={() => mailInvoice(row.id)}
                                                >
                                                    <SendIcon />
                                                </Button> 
                                        </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <Button
                                                  size="small"
                                                  color="success"
                                                  variant="contained"
                                                  disabled={row.status !== "Payment Complete"}
                                                  sx={{
                                                  borderRadius: 2,
                                                  boxShadow:
                                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                  "&:hover": {
                                                      boxShadow:
                                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                      backgroundColor: "#14213d",
                                                  },
                                                  }}
                                                  // onClick={() => generate_waybill(row.id)}
                                                  onClick={() => prepareWaybill(row)}
                                              >
                                                  <PaidIcon />
                                              </Button>
                                          </Typography>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <Button
                                                  size="small"
                                                  color="success"
                                                  variant="contained"
                                                  sx={{
                                                  borderRadius: 2,
                                                  boxShadow:
                                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                                  "&:hover": {
                                                      boxShadow:
                                                      "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                                      backgroundColor: "#14213d",
                                                  },
                                                  }}
                                                  // onClick={() => generate_waybill(row.id)}
                                                  onClick={() => resetWaybill(row)}
                                              >
                                                  <RestoreRoundedIcon />
                                              </Button>
                                          </Typography>
                                        </TableCell>
                                        
                                    </TableRow>
                                    ))}
                                </TableBody>
                                </Table>
                            </Box>
                        </Item>
                    </Grid>

                  <Grid item xs={12} md={12}>
                    <Box
                      sx={{
                        overflow: "auto",
                        marginBottom: 10,
                        maxHeight: 340,
                        "&::-webkit-scrollbar": {
                          width: "7px",
                          height: "7px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#f1f1f1",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#888",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#555",
                        },
                      }}
                    >
                      {!log_data ? (
                        <Typography
                          sx={{ m: 1 }}
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>No Requests</b>
                        </Typography>
                      ) : null}

                      <Table size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>No.</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Request Date</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Logistic</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Price/item</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Quantity</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total amount</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Status</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Invoice Listed</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Delete</b>
                              </Typography>{" "}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {log_data?.map((row, index) => (
                            <TableRow
                              key={row.index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                                backgroundColor: "#f5f3f4",
                              }}
                            >
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{index + 1}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>
                                    {formatDateToYearMonthDay(
                                      new Date(row.req_date)
                                    )}
                                  </b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.log_name}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.price_per?currencyFormat.format(row.price_per):"Not Set"}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.qty}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{currencyFormat.format(row.price_per * row.qty)}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.status}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>#{row.group_tag}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <Tooltip title="This action can not be undone">
                                    <Button
                                      size="small"
                                      color="error"
                                      variant="contained"
                                      sx={{
                                        borderRadius: 2,
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                        },
                                      }}
                                      onClick={() => deleteLog(row.id)}
                                    >
                                      <DeleteRoundedIcon />
                                    </Button>
                                  </Tooltip>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
          
          <Modal
              open={open_account}
              onClose={closeAccount}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
          >
            <Box sx={style1}>
              <Grid container spacing={.1}>
                <Grid item xs={12} md={4}>
                  <Typography
                      variant="h5"
                      sx={{ textAlign: "center", m: 1 }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                      <b>{editing_mode? 'Edit' : 'Add'} Kpee Account</b>
                  </Typography>

                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="account_type"
                      type='text'
                      value={formik.values.account_type}
                      onChange={formik.handleChange}
                      placeholder="Bank/Momo"
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="account_provider"
                      type='text'
                      value={formik.values.account_provider}
                      onChange={formik.handleChange}
                      placeholder="MTN/Fidelity"
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="account_name"
                      type='text'
                      value={formik.values.account_name}
                      onChange={formik.handleChange}
                      placeholder="Yaw Anim"
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="account_number"
                      type='text'
                      value={formik.values.account_number}
                      onChange={formik.handleChange}
                      placeholder="020..."
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="holders_contact"
                      type='text'
                      value={formik.values.holders_contact}
                      onChange={formik.handleChange}
                      placeholder="+233 20..."
                      fullWidth
                  />

                  <Box sx={{ display:'flex', flexDirection:'row' }}>
                    <Button
                      size="small"
                      color="error"
                      variant="contained"
                      sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                          boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                      },
                      }}
                      onClick={formik.handleReset}
                    >
                        Cancel
                    </Button>

                    <Button
                      size="small"
                      color="success"
                      variant="contained"
                      sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                          boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                      },
                      }}
                      onClick={formik.handleSubmit}
                    >
                        {editing_mode ? "Edit Account" : "Create Account"}
                    </Button>
                  </Box>
                </Grid>

                <Grid item xs={12} md={8}>
                  <Typography variant="h4" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                      <b>Kpee Accounts</b>
                  </Typography>
                  <Box
                      sx={{
                        overflow: "auto",
                        marginBottom: 10,
                        marginLeft: 2,
                        maxHeight: 340,
                        "&::-webkit-scrollbar": {
                            width: "7px",
                            height: "7px",
                        },
                        "&::-webkit-scrollbar-track": {
                            background: "#f1f1f1",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            background: "#888",
                            borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                            background: "#555",
                        },
                      }}
                  >
                      <Table size="small" aria-label="a dense table">
                      <TableHead>
                          <TableRow>
                          <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Holders Contact</b>
                              </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Type</b>
                              </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Provider</b>
                              </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Name</b>
                              </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Number</b>
                              </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Edit</b>
                              </Typography>{" "}
                          </TableCell>
                          <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Delete</b>
                              </Typography>{" "}
                          </TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {kpee_accounts?.map((row, index) => (
                          <TableRow
                              key={row.index}
                              sx={{
                              "&:last-child td, &:last-child th": {
                                  border: 0,
                              },
                              backgroundColor: "#f5f3f4",
                              }}
                          >
                              <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.holders_contact}</b>
                              </Typography>
                              </TableCell>
                              <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.account_type}</b>
                              </Typography>
                              </TableCell>
                              <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.account_provider}</b>
                              </Typography>
                              </TableCell>
                              <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.account_name}</b>
                              </Typography>
                              </TableCell>
                              <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.account_number}</b>
                              </Typography>
                              </TableCell>
                              <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <Button
                                      size="small"
                                      color="success"
                                      variant="contained"
                                      sx={{
                                      borderRadius: 2,
                                      boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                      "&:hover": {
                                          boxShadow:
                                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                      },
                                      }}
                                      onClick={() => editAccount(row)}
                                  >
                                      <EditNoteRoundedIcon />
                                  </Button> 
                              </Typography>
                              </TableCell>
                              <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                    size="small"
                                    color="error"
                                    variant="contained"
                                    sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                        boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                    },
                                    }}
                                    onClick={() => deleteAccount(row.id)}
                                >
                                    <DeleteRoundedIcon />
                                </Button> 
                              </Typography>
                              </TableCell>
                          </TableRow>
                          ))}
                      </TableBody>
                      </Table>
                  </Box>
                </Grid>
                <Grid item xs={12} md={10}></Grid>
                <Grid item xs={12} md={2}>
                  <Button
                    size="small"
                    color="error"
                    variant="contained"
                    sx={{
                    borderRadius: 2,
                    boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    "&:hover": {
                        boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                    },
                    }}
                    onClick={closeAccount}
                  >
                    Close
                  </Button> 
                </Grid>
              </Grid>
            </Box>
          </Modal>

          {/* group modal */}
          <Modal
              open={hold_waybill_open}
              onClose={closePreparedWaybill}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
          >
            <Box sx={style1}>
              <Grid container spacing={.1}>
                <Grid item xs={12} md={12}>
                  <Typography
                      variant="h3"
                      sx={{ textAlign: "center", m: .5 }}
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                      <b>WayBill</b>
                  </Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="dispatch_date"
                      type='date'
                      value={way_formik.values.dispatch_date}
                      onChange={way_formik.handleChange}
                      helperText="Dispatch Date"
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="delivery_method"
                      type='text'
                      value={way_formik.values.delivery_method}
                      onChange={way_formik.handleChange}
                      placeholder="Delivery Method (bus, train, plane...)"
                      helperText="Delivery Method (bus, train, plane...)"
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="delivery_company"
                      type='text'
                      value={way_formik.values.delivery_company}
                      onChange={way_formik.handleChange}
                      placeholder="Delivery Company (VIP, OA, British Airways...)"
                      helperText="Delivery Company (VIP, OA, British Airways...)"
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="driver_contact"
                      type='text'
                      value={way_formik.values.driver_contact}
                      onChange={way_formik.handleChange}
                      placeholder="Courier phone contact"
                      helperText="Courier phone contact"
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="driver_license_number"
                      type='text'
                      value={way_formik.values.driver_license_number}
                      onChange={way_formik.handleChange}
                      placeholder="Car license Number"
                      helperText="Car license Number"
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="driver_name"
                      type='text'
                      value={way_formik.values.driver_name}
                      onChange={way_formik.handleChange}
                      placeholder="Courier Name"
                      helperText="Courier Name"
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="delivery_address"
                      type='text'
                      value={way_formik.values.delivery_address}
                      onChange={way_formik.handleChange}
                      placeholder="Delivery Address"
                      helperText="Delivery Address"
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="receiver_contact"
                      type='text'
                      value={way_formik.values.receiver_contact}
                      onChange={way_formik.handleChange}
                      placeholder="Receiver Contact"
                      helperText="Receiver Contact"
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="receiver_name"
                      type='text'
                      value={way_formik.values.receiver_name}
                      onChange={way_formik.handleChange}
                      placeholder="Receiver Name"
                      helperText="Receiver Name"
                      fullWidth
                  />
                  <TextField
                      sx={{ m:1 }}
                      size="small"
                      required
                      name="receiver_address"
                      type='text'
                      value={way_formik.values.receiver_address}
                      onChange={way_formik.handleChange}
                      placeholder="Receiver Address"
                      helperText="Receiver Address"
                      fullWidth
                  />

                  <Box sx={{ display:'flex', flexDirection:'row' }}>
                    <Button
                      size="small"
                      color="error"
                      variant="contained"
                      sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                          boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                      },
                      }}
                      onClick={way_formik.handleReset}
                    >
                        Cancel
                    </Button>

                    <Button
                      size="small"
                      color="success"
                      variant="contained"
                      sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                          boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                      },
                      }}
                      onClick={way_formik.handleSubmit}
                    >
                      Update Waybill
                    </Button>
                  </Box>
                </Grid>
                  
                  <Grid item xs={1} md={1}></Grid>

                <Grid item xs={12} md={8}>
                  <Box sx={{ display:'flex' }}>
                    <Button
                      size="small"
                      color="success"
                      variant="contained"
                      sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                          boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                      },
                      }}
                      onClick={generateWaybill}
                    >
                      View Waybill 
                    </Button>
                    <Button
                      size="small"
                      color="success"
                      variant="contained"
                      sx={{
                      borderRadius: 2,
                      m: 1,
                      boxShadow:
                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      "&:hover": {
                          boxShadow:
                          "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                          backgroundColor: "#14213d",
                      },
                      }}
                      onClick={mailWaybill}
                    >
                      Send Waybill
                    </Button>
                  </Box>
                  <Typography sx={{textAlign:'center'}} variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                      <b>Delivery Information</b>
                  </Typography>

                  <Divider variant="middle" sx={{m:1}} />
                      
                    <Box sx={{ display:'flex', flexDirection:'row', justifyContent:'space-around' }}>
                      <Box>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                          <b>Dispatch Date: {hold_waybill?.dispatch_date?formatDateToYearMonthDay(new Date(hold_waybill?.dispatch_date)):""}</b>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                          <b>Delivery Method: {hold_waybill?.delivery_method}</b>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                          <b>Courier Phone Contact: {hold_waybill?.driver_contact}</b>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                          <b>Courier Name: {hold_waybill?.driver_name}</b>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                          <b>Car License Number: {hold_waybill?.driver_license_number}</b>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                          <b>Delivery Company: {hold_waybill?.delivery_company}</b>
                        </Typography>
                      </Box>
                      <Box>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                          <b>Delivery Address: {hold_waybill?.delivery_address}</b>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                          <b>Receiver Phone: {hold_waybill?.receiver_contact}</b>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                          <b>Receiver Name: {hold_waybill?.receiver_name}</b>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ textAlign: 'center' }}>
                          <b>Receiver Address: {hold_waybill?.receiver_address}</b>
                        </Typography>
                      </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={12}>
                <Box
                      sx={{
                        overflow: "auto",
                        marginBottom: 10,
                        maxHeight: 340,
                        "&::-webkit-scrollbar": {
                          width: "7px",
                          height: "7px",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "#f1f1f1",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#888",
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: "#555",
                        },
                      }}
                    >
                      {!log_data ? (
                        <Typography
                          sx={{ m: 1 }}
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        >
                          <b>No Requests</b>
                        </Typography>
                      ) : null}

                      <Table size="small" aria-label="a dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>No.</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Request Date</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Logistic</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Price/item</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Quantity</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total amount</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Status</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Invoice Listed</b>
                              </Typography>{" "}
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Delete</b>
                              </Typography>{" "}
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {hold_waybill.logs?.map((row, index) => (
                            <TableRow
                              key={row.index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                                backgroundColor: "#f5f3f4",
                              }}
                            >
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{index + 1}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>
                                    {formatDateToYearMonthDay(
                                      new Date(row.req_date)
                                    )}
                                  </b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.log_name}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.price_per?currencyFormat.format(row.price_per):"Not Set"}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.qty}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{currencyFormat.format(row.price_per * row.qty)}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>{row.status}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>#{row.group_tag}</b>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <Tooltip title="This action can not be undone">
                                    <Button
                                      size="small"
                                      color="error"
                                      variant="contained"
                                      sx={{
                                        borderRadius: 2,
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                        },
                                      }}
                                      onClick={() => deleteLog(row.id)}
                                    >
                                      <DeleteRoundedIcon />
                                    </Button>
                                  </Tooltip>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                </Grid>

                <Grid item xs={12} md={10}></Grid>
                <Grid item xs={12} md={2}>
                  <Button
                    size="small"
                    color="error"
                    variant="contained"
                    sx={{
                    borderRadius: 2,
                    boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    "&:hover": {
                        boxShadow:
                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                        backgroundColor: "#14213d",
                    },
                    }}
                    onClick={closePreparedWaybill}
                  >
                    Close
                  </Button> 
                </Grid>
              </Grid>
            </Box>
          </Modal>

        </Box>
      </main>
    </div>
  );
};

export default KpeeLogistics;
